const CrewTable = ({
  crews,
  editCrewMember,
  deleteCrewMember,
}) => {
  if (!crews || crews.length === 0) return null;

  return (
    <table className="w-full border-collapse mt-4">
      <thead>
        <tr>
          <th className="p-2 text-white border border-[#444] bg-[#222] text-left">
            Name
          </th>
          <th className="p-2 text-white border border-[#444] bg-[#222] text-left">
            Role
          </th>
          <th className="p-2 text-white border border-[#444] bg-[#222] text-left">
            Date
          </th>
          <th className="p-2 text-white border border-[#444] bg-[#222] text-left">
            Actions
          </th>
        </tr>
      </thead>
      <tbody>
        {crews.map((crew, index) => (
          <tr key={index}>
            <td className="p-2 text-white border border-[#444]">
              {crew.name}
            </td>
            <td className="p-2 text-white border border-[#444]">
              {crew.role}
            </td>
            <td className="p-2 text-white border border-[#444]">
              {crew?.date}
            </td>
            <td className="p-2 text-white border border-[#444] flex flex-row gap-2">
              <button
                type="button"
                onClick={() => editCrewMember(index)}
                className="px-3 py-1 bg-[#4CAF50] hover:bg-[#45a049] text-white text-sm rounded-md transition-colors"
              >
                Edit
              </button>
              <button
                type="button"
                onClick={() => deleteCrewMember(index)}
                className="px-3 py-1 bg-[#f44336] hover:bg-[#da190b] text-white text-sm rounded-md transition-colors"
              >
                Delete
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default CrewTable;